<template>
  <div>
    <span class="material-input-bar" />
    <label class="material-label">
      <slot />
    </label>
    <br v-if="$slots['default']" />
    <div v-for="language in languages" :key="language.code">
      <el-input
        :key="language.code"
        v-model="currentValue[language.code]"
        :loading="languagesLoading"
        v-bind="$attrs"
        :readonly="readonly"
        :disabled="disabled"
        @input="handleInput($event, language)"
      >
        <template slot="prepend">{{ language.description }}</template>
      </el-input>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    value: {
      default() {
        return {};
      },
      type: [Object, String]
    },
    readonly: Boolean,
    disabled: Boolean,
    languageCodes: {
      type: Array,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      currentValue: {}
    };
  },
  computed: {
    languages() {
      let languages = this.$store.getters['language/loadedItems'];
      if (this.languageCodes) {
        languages = languages.filter(language => this.languageCodes.find(code => code === language.code));
      }
      return languages;
    },
    languagesLoading() {
      return this.$store.getters['language/isLoading'];
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = [];
      if (newValue && newValue.translations) {
        newValue.translations.forEach(translation => {
          this.currentValue[translation.languageCode] = translation.text;
        });
      }
    }
  },
  methods: {
    handleInput(input, language) {
      const newValue = {
        ...this.value
      };
      const translation =
        newValue && newValue.translations && newValue.translations.find(t => t.languageCode === language.code);
      if (translation) {
        translation.text = input;
      } else {
        if (newValue.translations === undefined) {
          newValue['translations'] = [];
        }
        newValue.translations.push({
          languageCode: language.code,
          languageID: language.id,
          text: input
        });
      }
      this.$emit('input', newValue);
    }
  }
};
</script>

<style lang="scss">
.el-input-group__prepend {
  width: 120px !important;
  font-size: smaller;
  color: black;
}
</style>
